// Iris — met à jour le prix affiché dans le bouton "Ajouter au panier"
// au changement de variante (via l'event variant:change émis par <variant-picker>).

(function () {
  function money(cents) {
    var s = (cents / 100).toFixed(2).replace('.', ',').replace(/,00$/, '');
    return s + '\u00a0\u20ac';
  }

  function updatePriceForForm(formId, variant) {
    if (!formId || !variant) return;
    document
      .querySelectorAll('buy-buttons[form="' + formId + '"] [data-iris-atc-price]')
      .forEach(function (el) {
        el.textContent = money(variant.price);
      });
  }

  function init() {
    var forms = new Set();
    document.querySelectorAll('buy-buttons[form]').forEach(function (bb) {
      forms.add(bb.getAttribute('form'));
    });
    forms.forEach(function (formId) {
      var form = document.forms[formId];
      if (!form) return;
      form.addEventListener('variant:change', function (event) {
        var v = event.detail && event.detail.variant;
        updatePriceForForm(formId, v);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
